import { Component, TemplateRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { RegistrationFilterComponent } from 'src/app/components/validation/registration-filter/registration-filter.component';
import { SnapshotFilterComponent } from 'src/app/components/validation/snapshot-filter/snapshot-filter.component';
import { ValidationDashService } from 'src/app/service/validation-dash.service';
import { ResponseStatus } from 'src/enum/responseEnum';

export interface UserData {
  reg_id: string
  user_id: string,
  contact_number: string,
  name: string,
  source: string,
  validation_status: string,
  language: string,
  answer_type: string,
  create_dt: string,
  submitted_dt: string,
  user_cat: string
}
const ELEMENT_DATA: UserData[] = []

@Component({
  selector: 'app-validation-dashboard',
  templateUrl: './validation-dashboard.component.html',
  styleUrls: ['./validation-dashboard.component.css']
})


export class ValidationDashboardComponent {

  showSnapLoading: boolean = false;
  showRegistrationLoading: boolean = false;
  snapshotData: any;
  languageSnapData: any;
  languageValidator: any;
  // registrationListData: any;
  languageFilter: any;
  stateFilter: any;
  validationFilter: any;
  contestSourcesList: any;
  contestStatusesData: any;


  languageSnapColumn = ['language', 'total', 'completed'];


  registrationListColumnNoName = ['reg_id', 'contact_number', 'source', 'validation_status', 'submitted_dt', 'action']
  registrationListColumnAll = ['reg_id', 'contact_number', 'name', 'source', 'validation_status', 'submitted_dt', 'action']
  registrationListData = new MatTableDataSource(ELEMENT_DATA);
  registrationListColumn: any;

  currentPage: number = 1;
  pageSearch: string = '';
  totalRecords: any = 0;
  totalProducts: number = 0;
  pageLimit: number = 10;
  loading: boolean = true;
  isSearchActive: boolean = false;
  isExpandView: boolean = false;
  searchText = "";

  modalOption!: NgbModalOptions;
  modalReference: NgbModalRef | undefined;

  isFilterReset: boolean = false;
  snapFilterCount: number = 0;
  registrationFilterCount: number = 0;
  snapFilterData: any = {};
  registrationFilterData: any = {};
  uiPrivileges: any = {};

  constructor(private router: Router, private modalService: NgbModal, public validationService: ValidationDashService) {
    this.modalOption = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      windowClass: 'modal-medium-dialog'
    }

    let _uiPrivilege = localStorage.getItem("uiPrivileges")
    this.uiPrivileges = _uiPrivilege && JSON.parse(_uiPrivilege);
    if(this.uiPrivileges.nameInContestListing) {
      this.registrationListColumn = this.registrationListColumnAll;
    } else {
      this.registrationListColumn = this.registrationListColumnNoName;
    }

  }

  ngOnInit() {
    this.registrationFilterData = this.validationService.getFilterData();
    this.getContestdashboard(this.snapFilterData);
    this.getContestlang();
    this.getContestview(this.registrationFilterData);
    this.getLangfilter();
    this.getStatefilter();
    this.getValstatus();
    this.getContestSourcesData();
    this.getContestStatusesData();
  }

  onPageChange(page: any) {
    this.currentPage = page;
    this.getContestview(this.registrationFilterData);
  }

  // getProductListing() {
  //   this.loading = true;
  // }

  onPageSizeChange(page: any) {
    this.pageLimit = page;
    this.currentPage = 1;
    this.getContestview(this.registrationFilterData);
  }
  searchClick() {
    if(this.searchText.length > 0) {
      this.isSearchActive = true;
    } else {
      this.isSearchActive = !this.isSearchActive;
    }
  }
  searchInput(event: any) {
    this.searchText = event.target.value;

    this.currentPage = 1;
    this.pageLimit = 10;

    // const filterValue = event.target.value;

    // this.registrationListData.filter = filterValue.trim().toLowerCase();

    // console.log(this.registrationListData, filterValue.trim().toLowerCase(),"this.registrationListData")

    this.getContestview(this.registrationFilterData);
  }
  searchLeave(event: any) {
    // console.log(event, "event")
    this.searchText = event.target.value;
    if(this.searchText.length > 0) {
      this.isSearchActive = true;
    } else {
      this.isSearchActive = !this.isSearchActive;
    }
  }

  expandView() {
    this.isExpandView = !this.isExpandView;
  }

  routeDetails() {
    // this.router.navigateByUrl(`/validation-dash-details`);
  }
  countSnapFilterApplied() {
    this.snapFilterCount = 0;
    if (this.snapFilterData?.dateFrom && this.snapFilterData?.dateTo) {
      this.snapFilterCount++;
    }
    if (this.snapFilterData?.state?.length > 0) {
      this.snapFilterCount++;
    }
    if (this.snapFilterData?.status?.length > 0) {
      this.snapFilterCount++;
    }
    if (this.snapFilterData?.language?.length > 0) {
      this.snapFilterCount++;
    }
  }
  countRegistrationFilterApplied() {
    this.registrationFilterCount = 0;
    if (this.registrationFilterData?.stDtGrEq && this.registrationFilterData?.enDtLsEq) {
      this.registrationFilterCount++;
    }
    if (this.registrationFilterData?.valStatus?.length > 0) {
      this.registrationFilterCount++;
    }
    if (this.registrationFilterData?.langIn?.length > 0) {
      this.registrationFilterCount++;
    }
    if (this.registrationFilterData?.statusIn?.length > 0) {
      this.registrationFilterCount++;
    }
    if (this.registrationFilterData?.sourceIn?.length > 0) {
      this.registrationFilterCount++;
    }
  }


  openSnapFilterModal() {
    const modalRef = this.modalService.open(SnapshotFilterComponent, this.modalOption);
    modalRef.componentInstance.filterData = this.snapFilterData;
    modalRef.componentInstance.stateList = this.stateFilter;
    modalRef.componentInstance.validationStatusList = this.validationFilter;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry: any) => {

      this.snapFilterData = receivedEntry.data;

       console.log("receivedEntry.data - ",this.snapFilterData)
      this.isFilterReset = receivedEntry.isFilterReset;

      this.countSnapFilterApplied();
      this.getContestdashboard(this.snapFilterData);


      modalRef.close();

    })
    modalRef.componentInstance.close.subscribe((receivedEntry: any) => {
      modalRef.close();
    })

  }

  openRegistrationFilterModal(){
    const modalRef = this.modalService.open(RegistrationFilterComponent, this.modalOption);
    modalRef.componentInstance.filterData = this.registrationFilterData;
    modalRef.componentInstance.langInList = this.languageFilter;
    modalRef.componentInstance.valStatusList = this.validationFilter;
    modalRef.componentInstance.contestSourcesList = this.contestSourcesList;
    modalRef.componentInstance.contestStatusesData = this.contestStatusesData;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry: any) => {
      this.registrationFilterData = receivedEntry.data;

      this.isFilterReset = receivedEntry.isFilterReset;

      this.countRegistrationFilterApplied();
      this.currentPage = 1;
      this.pageLimit = 10;
      this.getContestview(this.registrationFilterData);
      this.validationService.setFilterData(this.registrationFilterData);


      modalRef.close();

    })
    modalRef.componentInstance.close.subscribe((receivedEntry: any) => {
      modalRef.close();
    })

  }

  getContestdashboard(params?:any) {
    console.log('params - ', params)
    this.showSnapLoading = true;
    let payload = {
      stDtGrEq: (params?.dateFrom == "" || params?.dateFrom == undefined) ? "" : moment(params?.dateFrom).format("YYYY-MM-DD"),
      enDtLsEq: (params?.dateTo == "" || params?.dateTo == undefined) ? "" : moment(params?.dateTo).format("YYYY-MM-DD"),
      statusIn: (params?.status == undefined || params?.status?.length == 0) ? "" : params?.status,
      stateIn: (params?.state == undefined || params?.state?.length == 0) ? "" : params?.state,
    }

    const filteredPayload: any = Object.fromEntries(
      Object.entries(payload).filter(([_, v]) => v !== "" && v !== undefined)
    );

    this.validationService.fetchContestdashboard(filteredPayload).then((res:any) => {
      if (res.status === ResponseStatus.SUCCESS) {
        this.snapshotData = res.records[0];
        this.showSnapLoading = false;
      }
    }).catch((error:any) => {
      console.log(error)
      this.showSnapLoading = false;
    })
  }

  getContestlang(params?:any) {
    this.validationService.fetchContestlang(params).then((res:any) => {
      if (res.status === ResponseStatus.SUCCESS) {
        this.languageSnapData = res.records;
      }
    }).catch((error:any) => {
      console.log(error)
    })
  }
  getContestview(params?:any) {

    console.log("getContestview - params -", params)
    console.log("getContestview - ", this.registrationFilterData)
    this.showRegistrationLoading = true;

    let payload = {
      start: (this.currentPage - 1) * this.pageLimit,
      size: this.pageLimit,
      statusIn: (params?.statusIn == undefined || params?.statusIn == "" || params?.statusIn?.length == 0) ? "" : params?.statusIn,
      sourceIn: (params?.sourceIn == undefined || params?.sourceIn == "" || params?.sourceIn?.length == 0) ? "" : params?.sourceIn,
      langIn: (params?.langIn == undefined || params?.langIn == "" || params?.langIn?.length == 0) ? "" : params?.langIn,
      valStatusIn: (params?.valStatus == undefined || params?.valStatus == "" || params?.valStatus?.length == 0) ? "" : params?.valStatus,
      stDtGrEq: (params?.stDtGrEq == undefined || params?.stDtGrEq == "") ? "" : moment(params?.stDtGrEq).format("YYYY-MM-DD"),
      enDtLsEq: (params?.enDtLsEq == undefined || params?.stDtGrEq == "") ? "" : moment(params?.enDtLsEq).format("YYYY-MM-DD"),
      searchLike: this.searchText
    }

    const filteredPayload: any = Object.fromEntries(
      Object.entries(payload).filter(([_, v]) => v !== "" && v !== undefined)
    );

    this.validationService.fetchContestview(filteredPayload).then((res:any) => {
      if (res.status === ResponseStatus.SUCCESS) {
       this.registrationListData.data = this.updateObjects(res.records);

        console.log(this.registrationListData.data, "this.registrationListData.data")

       this.totalRecords = res.totalRecords;
       this.showRegistrationLoading = false;
      }
    }).catch((error:any) => {
      console.log(error)
      this.showRegistrationLoading = false;
    })
  }
  getLangfilter() {
    this.validationService.fetchLangfilter().then((res:any) => {
      if (res.status === ResponseStatus.SUCCESS) {
       this.languageFilter = res.records;
      }
    }).catch((error:any) => {
      console.log(error)
    })
  }
  getStatefilter() {
    this.validationService.fetchStatefilter().then((res:any) => {
      if (res.status === ResponseStatus.SUCCESS) {
       this.stateFilter = res.records;
      }
    }).catch((error:any) => {
      console.log(error)
    })
  }
  getValstatus() {
    this.validationService.fetchValstatus().then((res:any) => {
      if (res.status === ResponseStatus.SUCCESS) {
        this.validationFilter = res.records;
      }
    }).catch((error:any) => {
      console.log(error)
    })
  }
  getContestSourcesData() {
    this.validationService.fetchContestSourcesData().then((res:any) => {
      if (res.status === ResponseStatus.SUCCESS) {
        this.contestSourcesList = res.data;
      }
    }).catch((error:any) => {
      console.log(error)
    })
  }
  getContestStatusesData() {
    this.validationService.fetchContestStatusesData().then((res:any) => {
      if (res.status === ResponseStatus.SUCCESS) {
        this.contestStatusesData = res.data;
      }
    }).catch((error:any) => {
      console.log(error)
    })
  }


  consvertNumber(value: any) {

    if(value == null) {
      return 0;
    }

    if (typeof value === 'string') {
      value = value.replace(/-/g, '0');
    }

    if (!isNaN(value)) {
        //var output = Number(input).toLocaleString('en-IN');   <-- This method is not working fine in all browsers!
        const result = value.toString().split('.')

        let lastThree = result[0].substring(result[0].length - 3)
        let otherNumbers = result[0].substring(0, result[0].length - 3)
        if (otherNumbers != '' && otherNumbers != '-')
            lastThree = ',' + lastThree
            let output = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree

        if (result.length > 1) {
            output += '.' + result[1]
        }

        return output
    }
  }

    // Split answer_type into an array of types

  updateObjects(arr:any) {
    return arr.map((obj:any) => ({
      id: obj.id || "-",
      reg_id: obj.reg_id || "-",
      user_id: obj.user_id || "-",
      status: obj.status || "-",
      contact_number: obj.contact_number || "-",
      name: obj.name || "-",
      source: obj.source || "-",
      validation_status: obj.validation_status || "-",
      language: obj.language || "-",
      answer_type: obj.answer_type || "-",
      create_dt: obj.create_dt || "-",
      submitted_dt: obj.submitted_dt || "-",
      user_cat: obj.user_cat || "-",
      isEditEnabled: obj.isEditEnabled
    }));
  }

  convertDate(date:any) {
    if(date == "-") {
      return "-";
    }

    return moment(date).format('DD-MM-YYYY');
  }

  maskPhoneNumber(phoneNumber:any) {
    if (typeof phoneNumber !== 'string') {
      phoneNumber = phoneNumber.toString(); // Ensure phoneNumber is a string
    }

    // Mask the phone number
    return phoneNumber.substring(0, 3) + 'xxxx' + phoneNumber.substring(7);
  }


}
